import React from "react";
import "../style.scss";
import Select from "react-select";
import clsx from "clsx";
import { handleOnBlurFreezeTable, handleOnFocusFreezeTable } from "utils/all";
import { isNull } from "App/utils/helpers";

export default function InputFieldOption(props) {
  const {
    id,
    label,
    name,
    className,
    disabled = false,
    data,
    error,
    message,
    value,
    labelValue = "",
    defaultLabel = "",
    onChange,
    withSearch = false,
    needParse = true,
    optionIsNotDisabled = [],
    isSpecificDisabled = false,
    isMulti = false,
    isClearable = false,
    ...other
  } = props;

  const checked = isNull(value) ? "" : needParse ? parseInt(value) : value;

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "gray" : state.isSelected ? "#fff" : "black",
      fontSize: "10px",
    }),
    control: (base) => ({
      ...base,
      "&:hover": { borderColor: "#296218" },
      border: "1px solid lightgray",
      boxShadow: "none",
      borderRadius: "4px",
      fontSize: "10px",
      overflow: "hidden",
      minHeight: 34,
      menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    }),

    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  const RenderCompWithoutSearch = () => {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <select
          disabled={disabled}
          name={name}
          id={id}
          onChange={onChange}
          value={checked}
          isClearable={isClearable}
          {...other}
          className={clsx("form-control text", className)}
        >
          {data?.map((item, index) => {
            return (
              <option
                value={item.value}
                key={index}
                disabled={item.disabled === true ? true : false}
              >
                {item.label}
              </option>
            );
          })}
        </select>
      </div>
    );
  };

  const RenderCompWithSearch = () => {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <Select
          id={id}
          name={name}
          isClearable={true}
          isDisabled={disabled}
          onChange={onChange}
          onBlur={handleOnBlurFreezeTable}
          onFocus={handleOnFocusFreezeTable}
          options={data}
          defaultValue={
            isMulti
              ? null
              : {
                  label: `Pilih ${defaultLabel}`,
                  value: "",
                }
          }
          isMulti={isMulti}
          value={
            labelValue !== ""
              ? isMulti
                ? value
                : {
                    label: labelValue,
                    value: value === null ? "" : value,
                  }
              : undefined
          }
          // menuPortalTarget={document.body}
          menuPosition={"fixed"}
          menuShouldBlockScroll={true}
          styles={customStyles}
          classNamePrefix="select-custom"
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              text: "orangered",
              primary25: "#adcfa3",
              primary: "#296218",
            },
          })}
          isOptionDisabled={(option) => {
            if (isSpecificDisabled) {
              const isDisabled = optionIsNotDisabled.filter(
                (item) => parseInt(item) === parseInt(option.value)
              );
              return isDisabled.length > 0 ? false : true;
            } else {
              return false;
            }
          }}
        />
      </div>
    );
  };

  if (withSearch) {
    return <RenderCompWithSearch />;
  } else {
    return <RenderCompWithoutSearch />;
  }
}
